(function () {
    'use strict';
    angular.module('Services').factory('ServiceTicketsLogsTable', ServiceTicketsLogsTable);

    ServiceTicketsLogsTable.$inject = [
        'TableLiteFactory',
        'ServiceRequestTicketService',
        'toastr',
        '$filter',
        '$uibModal',
        '$location'
    ];

    function ServiceTicketsLogsTable(
        TableLiteFactory,
        ServiceRequestTicketService,
        toastr,
        $filter,
        $uibModal,
        $location
    ) {
        return function (ticketId) {
            const tableStructure = {
                tableName: 'ServiceTicketsLogsTable',
                config: {
                    noConfigureTable: true,
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: true,
                    noExtraction: true,
                    noFooter:true
                },
                optionAddOns: {
                    buttons: [],
                },
                headers: [ {
                    label: 'Actions',
                    viewName: 'action',
                    filterName: 'action',
                   
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'Update Field Name',
                    viewName: 'fieldName',
                    filterName: 'fieldName',
                    width: '150px',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'Old Value',
                    viewName: 'oldValue',
                    filterName: 'oldValue',
                    width: '150px',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'New Value',
                    viewName: 'newValue',
                    filterName: 'newValue',
                    width: '150px',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },{
                    label: 'User Name',
                    viewName: 'actorName',
                    filterName: 'actorName',
                    width: '150px',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Date/Time',
                    viewName: 'createdAt',
                    filterName: 'createdAt',
                    width: '135px',
                   
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: ServiceRequestTicketService.getTicketLogs,
                paramId: ticketId,
                callbackFormat: ['id','success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData();
                    toastr.error(err.message, 'Error');
                },
                defaultFilters: {
                    size: 20,
                    page: 0
                }
            });

            function buildTableData(data) {
                if (!data) { return; }
                //tableActions.initializeTableData(data);
                angular.forEach(data, (item) => {
                    // item.createdAt = $filter('bbaDate')(item.createdAt);
                    // item.commentText = item.commentText || 'N/A';
                    // item.authorName = item.authorName || 'N/A';
                    
                    tableStructure.data.push(item);
                });
            }

            this.tableData = tableStructure;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/service-ticket-tables/ServiceTicketsLogsTable.js